import ReactGA from 'react-ga4';

class ReactGAChannel {
  constructor(trackingId) {
    ReactGA.initialize(trackingId);
  }

  sendPageView(event) {
    ReactGA.send({
      hitType: "pageview",
      country: event.country,
      full_url: event.url,
      referrer: document.referrer,
      user_id: event.id,
      user_type: event.role,
      user_uuid: null,
      user_agent: event.userAgent,
      registration_type: "unknown",
      cd1: "unknown",
      cd2: "unknown",
      cd3: event.userUuid || "unknown",
    });
  }

  sendPageEvent(event) {
    ReactGA.send({
      hitType: "event",
      eventCategory: "pageevent",
      eventAction: event.action,
      eventLabel: "Custom DinoLab olymp Event",
      country: event.country,
      full_url: event.url,
      user_id: event.id,
      user_type: event.role,
      user_uuid: null,
      user_agent: event.userAgent,
      registration_type: "unknown",
      event_info: event.payload,
      cd1: "unknown",
      cd2: "unknown",
      cd3: event.userUuid || "unknown",
    });
  }
}

export default ReactGAChannel;
